import { z } from 'zod';
import type { SchemaEntry } from '../create-field-schema-registry';
import { ERRORS } from './errors';

export const email = () => z
  .string({ error: ERRORS.EMPTY })
  .superRefine((value, ctx) => {
    if (!value?.trim()) {
      ctx.addIssue({ code: 'custom', message: ERRORS.EMPTY });
      return;
    }

    if (!z.email().safeParse(value).success) {
      ctx.addIssue({ code: 'custom', message: ERRORS.INVALID_EMAIL });
    }
  });

export default ['email', email] as const satisfies SchemaEntry;
